import { storage } from '@/tools/storage'

export default {
  isGoogleShoppingProduct(productId) {
    const urlParams = new URLSearchParams(window.location.search)
    const sourceIsGoogleShopping = urlParams.get('g_campaign')
    const products = storage.session.get('googleShoppingProducts') || []

    if (products.includes(productId)) return true

    if (sourceIsGoogleShopping === 'google_shopping') {
      products.push(productId)
      storage.session.set('googleShoppingProducts', products)

      return true
    }

    return false
  }
}
